import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsPanel = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Active Permits',
      value: metrics?.activePermits,
      icon: 'FileCheck',
      color: 'text-emerald-600 dark:text-emerald-400',
      bgColor: 'bg-emerald-100 dark:bg-emerald-900/30'
    },
    {
      label: 'Pending Approvals',
      value: metrics?.pendingApprovals,
      icon: 'Clock',
      color: 'text-amber-600 dark:text-amber-400',
      bgColor: 'bg-amber-100 dark:bg-amber-900/30'
    },
    {
      label: 'Expiring Soon',
      value: metrics?.expiringSoon,
      icon: 'AlertTriangle',
      color: 'text-red-600 dark:text-red-400',
      bgColor: 'bg-red-100 dark:bg-red-900/30'
    },
    {
      label: 'Total This Month',
      value: metrics?.totalThisMonth,
      icon: 'TrendingUp',
      color: 'text-blue-600 dark:text-blue-400',
      bgColor: 'bg-blue-100 dark:bg-blue-900/30'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 shadow-sm">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-12 h-12 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{metric?.value}</p>
          <p className="text-sm text-muted-foreground">{metric?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default MetricsPanel;